/**
 * Audit log utilities.
 * Re-exports entity config for audit log categories and resources.
 */
export {
	AUDIT_CATEGORY_CONFIG,
	AUDIT_RESOURCE_CONFIG,
	getCategoryConfig,
	getResourceConfig,
} from "./entity-config";

const formatAuditDateTime = (
	dateStr: string,
	locale = "en-US",
	options: Intl.DateTimeFormatOptions = {
		year: "numeric",
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	},
): string => {
	const date = new Date(dateStr);
	return date.toLocaleString(locale, options);
};

export { formatAuditDateTime };
